import React from "react";

import "./EquipmentHardwareItemStyle.css";

const EquipmentHardwareItem = ({ icon, label }) => {
  return (
    <div className="equipmentHardware-item">
      <span className="icon">{icon}</span>
      <p className="label">{label}</p>
    </div>
  );
};

export default EquipmentHardwareItem;
